import { api } from '@services';

interface IRequest {
  ids: string[];
}

const deleteMassEquipments = async ({ ids }: IRequest): Promise<void> => {
  const data = { ids: ids.join() };
  await api.delete(`/equipments/mass`, { data });
};

export { deleteMassEquipments };
